// Lands at /google/callback after Google's OAuth consent screen.
// Extracts ?code and ?state from the URL, posts them to the BE for
// exchange, then bounces the operator back to where they were.
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useGoogleCallback } from "../api/hooks/useDriveSync";
import { HOME_PATH } from "../utils/homePath";
import { GOOGLE_RETURN_TO_KEY, googleCallbackUri } from "../utils/useConnectGoogle";

export const GoogleAuthCallbackRoute = () => {
  const [params] = useSearchParams();
  const code = params.get("code");
  const state = params.get("state");
  const error = params.get("error");
  const navigate = useNavigate();
  const callback = useGoogleCallback();
  const [status, setStatus] = useState<"working" | "error">("working");
  const [errorText, setErrorText] = useState<string | null>(null);

  useEffect(() => {
    if (error) {
      setStatus("error");
      setErrorText(`Google declined the authorization: ${error}`);
      return;
    }
    if (!code || !state) {
      setStatus("error");
      setErrorText("Missing code or state on the callback URL.");
      return;
    }
    const redirectUri = googleCallbackUri();
    callback
      .mutateAsync({ code, state, redirect_uri: redirectUri })
      .then(() => {
        const returnTo = sessionStorage.getItem(GOOGLE_RETURN_TO_KEY) ?? HOME_PATH;
        sessionStorage.removeItem(GOOGLE_RETURN_TO_KEY);
        navigate(returnTo, { replace: true });
      })
      .catch((e: Error) => {
        setStatus("error");
        setErrorText(e.message || "OAuth exchange failed.");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "error") {
    return (
      <div style={{ padding: 24, maxWidth: 600 }}>
        <h2>Google authorization failed</h2>
        <p>{errorText}</p>
        <p>
          <a href={HOME_PATH}>Return to the dashboard</a>
        </p>
      </div>
    );
  }
  return (
    <div style={{ padding: 24 }}>
      <p>Finishing Google authorization…</p>
    </div>
  );
};
